import {
  MICROFRONTEND_ROUTES,
  type MicrofrontendRoutes,
} from "@spiriidk/connect-configs";
import { getFlag } from "@spiriidk/feature-flags";

const isRouteServedBy = (
  pathname: string,
  microfrontend: keyof MicrofrontendRoutes
): boolean => {
  const config = MICROFRONTEND_ROUTES[microfrontend];
  return config.paths.some((path) => pathname.startsWith(path));
};

/**
 * Determines if a route is served by the connect app. A static `paths` match
 * always wins; a `migratedPaths` entry is connect-owned only while its flag
 * evaluates on. If the provider is not ready yet, `getFlag` returns the config
 * default (`off`), so the path falls through to the legacy tech-ui catch-all —
 * the safe failure mode (design D1).
 */
const isConnectRoute = (pathname: string): boolean => {
  if (isRouteServedBy(pathname, "connect")) {
    return true;
  }

  const { migratedPaths } = MICROFRONTEND_ROUTES.connect;
  if (!migratedPaths) {
    return false;
  }

  return Object.entries(migratedPaths).some(
    ([path, flag]) => pathname.startsWith(path) && getFlag(flag)
  );
};

/**
 * Determines if a route is served by the techUi app.
 */
const isTechUiRoute = (pathname: string): boolean => {
  return isRouteServedBy(pathname, "techUi");
};

export { isRouteServedBy, isConnectRoute, isTechUiRoute };
